import { type Job } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Admin-only: release a job's recommendation (ADR 0004). Invalidating
 * `jobs` also refetches the job's candidates, whose status the release
 * changes for recruiters. */
export function useReleaseRecommendation(): UseMutationResult<Job, Error, string> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId) => client.releaseRecommendation(jobId),
    onSuccess: (job) => {
      qc.setQueryData(queryKeys.job(job.id), job);
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
